import { useEffect, useState } from 'react';
import { Modal } from '@/components/ui/Modal';

interface ShortcutItem {
  keys: string;
  description: string;
}

const SHORTCUTS: ShortcutItem[] = [
  { keys: 'Ctrl+Enter', description: 'Compute bioavailability result' },
  { keys: 'Ctrl+S', description: 'Save current study' },
  { keys: 'Enter', description: 'In data table: advance to next row' },
  { keys: 'Esc', description: 'Close dialog or popover' },
  { keys: '?', description: 'Open this shortcut list' },
];

export function ShortcutHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === '?' && !e.ctrlKey && !e.metaKey) {
        const target = e.target as HTMLElement;
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return;
        e.preventDefault();
        setOpen((v) => !v);
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!open) return null;

  return (
    <Modal open={open} title="Keyboard Shortcuts" onClose={() => setOpen(false)}>
      <p className="field-hint mt-0">Press these keys anywhere in the app to trigger actions.</p>
      <table className="generic-table">
        <thead>
          <tr>
            <th>Key</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {SHORTCUTS.map((s) => (
            <tr key={s.keys}>
              <td><kbd className="kbd">{s.keys}</kbd></td>
              <td className="field-hint">{s.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  );
}
